import fileDownload from 'js-file-download'

import { BaseQueryResult } from '@reduxjs/toolkit/dist/query/baseQueryTypes'

export const fileHandler = async (res: Response) => {
  if (res.status === 500) {
    return res.json()
  } else {
    const data = await res.blob()
    const filename = res.headers.get('x-suggested-filename') as string
    fileDownload(data, filename)
    return { message: 'successfully downloaded file' }
  }
}
